/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_No_Obligation_TitleInputs */

const fr_help_no_obligation_title = /** @type {(inputs: Help_No_Obligation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas d'obligation`)
};

const en_help_no_obligation_title = /** @type {(inputs: Help_No_Obligation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No obligation`)
};

/**
* | output |
* | --- |
* | "No obligation" |
*
* @param {Help_No_Obligation_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_no_obligation_title = /** @type {((inputs?: Help_No_Obligation_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_No_Obligation_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_no_obligation_title(inputs)
	return en_help_no_obligation_title(inputs)
});